import React from "react";
import moment from "moment";
import AppIcon from "../../images/appIcon.png";
import "./MoleculeStyles.scss";

export default function ChatListItem({ item, activeChat, selected }) {
  const { avatar, name, preview, date, unread } = item;
  const dateFormatted = moment(date).fromNow();

  const pressed = () => {
    if (item && selected) {
      selected(item);
    }
  };

  return (
    <div
      className={`chat_list_item${activeChat?.id == item.id ? " chat_list_item--active" : ""}${unread ? " chat_list_item--unread" : ""}`}
      onClick={pressed}
    >
      <img
        className="chat_list_item_avatar"
        src={avatar ? avatar : AppIcon}
      />
      <div className="chat_list_item_body">
        <div className="chat_list_item_name">{name}</div>
        <div className="chat_list_item_preview">{preview}</div>
      </div>
      <div className="chat_list_item_meta">
        <div className="chat_list_item_date">{dateFormatted}</div>
        {unread && <div className="chat_list_item_unread_dot" />}
      </div>
    </div>
  );
}
